import axios from 'axios';
import config from '../config/config';

class LogbookApi {
    static loadLogbookEntries(lastUpdateCall) {
        return axios.get(`${config.server.endpoint}backend/logbook/${lastUpdateCall && lastUpdateCall.getTime ? lastUpdateCall.getTime() : '0'}`)
    }

    static loadAvailableAssignees() {
        return axios.get(`${config.server.endpoint}backend/logbook/assignees`)
    }

    static addEntry(payload) {
        return axios.post(`${config.server.endpoint}backend/logbook`, {
            ...payload
        })
    }

    static editEntry(entryId, payload) {
        return axios.put(`${config.server.endpoint}backend/logbook/${entryId}`, {
            ...payload
        })
    }

    static deleteEntry(entryId) {
        return axios.delete(`${config.server.endpoint}backend/logbook/${entryId}`)
    }

    static bookmarkEntry(entryId, payload) {
        return axios.post(`${config.server.endpoint}backend/logbook/${entryId}/bookmark`, {
            ...payload
        })
    }

    static addComment(entryId, payload) {
        return axios.post(`${config.server.endpoint}backend/logbook/${entryId}/comment`, {
            ...payload
        })
    }

    static editComment(commentId, payload) {
        return axios.put(`${config.server.endpoint}backend/logbook/comment/${commentId}`, {
            ...payload
        })
    }

    static deleteComment(commentId) {
        return axios.delete(`${config.server.endpoint}backend/logbook/comment/${commentId}`)
    }

    static changeStatus(entryId, payload) {
        return axios.put(`${config.server.endpoint}backend/logbook/${entryId}/status`, {
            ...payload
        })
    }

    static changeAssignee(entryId, payload) {
        return axios.put(`${config.server.endpoint}backend/logbook/${entryId}/assignee`, {
            ...payload
        })
    }
}

export default LogbookApi;
